var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.appraisal.title'),
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.value.title,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "title", $$v);
      },
      expression: "value.title"
    }
  })], 1), _vm.value.lineItems.length > 0 ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$t('objects.appraisal.currency'),
      "clearable": "",
      "outlined": "",
      "return-object": "",
      "auto-select-first": "",
      "items": Object.values(_vm.CurrencyEnum),
      "filter": _vm.getAutocompleteFilter(function (e) {
        return [e];
      }),
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.value.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "currency", $$v);
      },
      expression: "value.currency"
    }
  })], 1) : _vm._e(), _vm.value.lineItems.length > 0 ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('line-items-form', {
    attrs: {
      "readonly": _vm.disabled,
      "showProducts": false
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": _vm.$t('objects.appraisal.residualValueNet'),
      "persistent-hint": "",
      "outlined": "",
      "clearable": "",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.value.residualValueNet,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "residualValueNet", _vm._n($$v));
      },
      expression: "value.residualValueNet"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": _vm.$t('objects.appraisal.replacementValueNet'),
      "persistent-hint": "",
      "outlined": "",
      "clearable": "",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.value.replacementValueNet,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "replacementValueNet", _vm._n($$v));
      },
      expression: "value.replacementValueNet"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": Object.values(_vm.TotalLossType),
      "label": _vm.$t('objects.appraisal.totalLoss'),
      "outlined": "",
      "clearable": "",
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.$t("enums.TotalLossType.".concat(item))) + " ")];
      }
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$t("enums.TotalLossType.".concat(item))) + " ")];
      }
    }]),
    model: {
      value: _vm.value.totalLoss,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "totalLoss", $$v);
      },
      expression: "value.totalLoss"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": _vm.$t('objects.appraisal.diminishedValueNet'),
      "persistent-hint": "",
      "outlined": "",
      "clearable": "",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.value.diminishedValueNet,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "diminishedValueNet", _vm._n($$v));
      },
      expression: "value.diminishedValueNet"
    }
  })], 1), _vm.showDate ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "date",
      "label": _vm.$t('components.PartnerReportDetail.repair.ReportAppraisalCreateDialog.dateLabel'),
      "persistent-hint": "",
      "outlined": "",
      "hint": _vm.$t('components.PartnerReportDetail.repair.ReportAppraisalCreateDialog.dateHint'),
      "clearable": "",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.value.dateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "dateFormable", $$v);
      },
      expression: "value.dateFormable"
    }
  })], 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }